export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8725.1ca52fb9.jpg";